export enum AlertingTab {
  Notifications,
  Monitors,
  Alerts,
  Recipients,
  Approvers,
}
